import { render, staticRenderFns } from "./LeadgenTable.vue?vue&type=template&id=63771898&"
import script from "./LeadgenTable.vue?vue&type=script&lang=js&"
export * from "./LeadgenTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports